// extracted by mini-css-extract-plugin
export default {"container":"CustomScrollbar__container___S_H_L","trackY":"CustomScrollbar__trackY___Ag8hB","thumbY":"CustomScrollbar__thumbY___CgnDE"};